module.exports = __webpack_public_path__ + "img/medicines.62d34995.svg";